<template>
    <!-- <div class="logo-top">
      <img src="../assets/img/login/logo03.png">
    </div> -->
    <div class="center-div">
      <div class="center-box flex-center">
        <div class="right-box ">
          <div class="login-form flex-center-column">
            <inline-sms-verification
              v-if="smsVerificationVisible"
              v-model="verificationCode"
              :phone="verificationPhone"
              :code-button-text="codeButtonText"
              :code-sending="codeSending"
              :code-countdown="codeCountdown"
              :sms-verifying="smsVerifying"
              @back="closeSmsVerification"
              @get-code="getVerificationCode"
              @verify="verifySmsCode"
            />
            <template v-else>
              <img src="../assets/img/phoneHead.png" alt="" srcset="">
              <div class="t1">欢迎登录管理后台</div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="login-ruleForm">
                <div class="flex-center-column">
                  <el-input placeholder="请输入您的账号" prefix-icon="el-icon-user" v-model="ruleForm.username"> </el-input>
                  <el-input type="password" prefix-icon="el-icon-lock" v-model="ruleForm.password" show-password placeholder="请输入您的密码"> </el-input>
                  <el-button type="primary" @click="login()">立即登录</el-button>
                </div>
              </el-form>
            </template>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import { Notice } from "../components/Notice/Notice.js";
import { User } from "../components/HospitalDomain/User.js";
import { Role } from "../components/HospitalDomain/Role";
import LoginSmsVerificationMixin from "../mixins/LoginSmsVerification.js";
import InlineSmsVerification from "../components/LoginSmsVerification/InlineSmsVerification.vue";
export default {
  name: "login",
  mixins: [LoginSmsVerificationMixin],
  components: {
    InlineSmsVerification
  },
  data() {
    var role = new Role(this.TokenClient, this.Services.Authorization);
    var notice = new Notice(this.TokenClient, this.Services.Notice);
    return {
      Notice: notice,
      RoleDomain: role,
      checked: false,
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 15, message: "长度在 3 到 15 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, max: 15, message: "长度在 3 到 15 个字符", trigger: "blur" },
        ],
      },
      noticeInfo: {
        isEnable: false,
      },
    };
  },
  mounted() {
    this.getNotice();
  },
  methods: {
    getNotice() {
      var _this = this;
      _this.Notice.GetNotice(
        function (data) {
          _this.noticeInfo = data.data;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    //登录
    login(loginResult) {
      var _this = this;
      let { username, password } = this.ruleForm;
      let userInfo = new User(this.TokenClient, this.Services.Authorization);
      if (!loginResult) {
        loginResult = userInfo.Login(username.replace(/(^\s*)|(\s*$)/g, ""), password.replace(/(^\s*)|(\s*$)/g, ""));
      }
      if (loginResult.success) {
        _this.RoleDomain.AllManagerMenus(
          function (data) {
            let keys = Object.keys(data.data)[0];
            if (keys && data.data[keys].length > 0) {
              sessionStorage.setItem("AllMenus", JSON.stringify(data.data[keys]));
              if (localStorage.getItem("isAllowPlayAudio") == null) {
                localStorage.setItem("isAllowPlayAudio", false);
              }
              if (_this.ClientId == _this.YunClient || _this.ClientId == _this.TotalClient || _this.ClientId == _this.AssociationClient || _this.ClientId == _this.FairClient) {
                _this.$router.push("/Outpatient/ChargedListPhone");
              } else {
                _this.$router.push("/Outpatient/ChargedListPhone");
              }
            } else {
              this.$message.error("请联系管理员！");
            }
          },
          function (err) {
            // sessionStorage.setItem('AllMenus', JSON.stringify(err.data.机构后台))
            // _this.$router.push('/index'); 
            let keys = Object.keys(err.data)[0];
            if (keys && err.data[keys].length > 0) {
              sessionStorage.setItem("AllMenus", JSON.stringify(err.data[keys]));
              if (localStorage.getItem("isAllowPlayAudio") == null) {
                localStorage.setItem("isAllowPlayAudio", false);
              }
                if (_this.ClientId == _this.YunClient || _this.ClientId == _this.TotalClient || _this.ClientId == _this.AssociationClient || _this.ClientId == _this.FairClient) {
                  _this.$router.push("/ChargedListPhone");
                } else {
                  _this.$router.push("/ChargedListPhone");
                }
            } else {
              this.$message.error("请联系管理员！");
            }
          }
        );
      } else if (loginResult.requiresSmsVerification) {
        this.openSmsVerification(username);
      } else {
        this.$message.error(loginResult.message || "账号密码错误，请重新输入！");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .center-box {
    .right-box {
      width: 100%;
      height: 100vh;
      background: linear-gradient(0deg, #E4EFFF, #F4F4FF);
      .login-form {
        margin: 15% auto;
        img {
          width: 60px;
          height: 60px;
        }
        .t1 {
          font-size: 22px;
          font-weight: 400;
          color: var(--base--Color);
          text-align: center;
          color: #333333;
        }
        ::v-deep .el-input {
          margin-bottom: 2vh;
        }

        .login-ruleForm {
          margin-top: 5vh;
          width: 85%;
          ::v-deep .el-input__icon {
            color: #333333;
            height: 60px;
            line-height: 60px;
            font-size: 20px;
          }

          ::v-deep .el-input__prefix {
            left: 15px;
            height: 60px;
          }
          ::v-deep .el-input__inner {
            height: 60px;
            padding: 10px 30px 10px 60px;
            padding-left: 50px;
            border: 1px solid #e6e6e6;
            border-radius: 6px;
          }

          .el-button {
            margin-top: 1vh;
            width: 100%;
            height: 60px;
            border-radius: 20px;
            background: var(--base--Color);
            font-size: 18px;
            color: #ffffff;
            border: none;
          }

          .el-checkbox {
            color: #ffffff;

            .el-checkbox__input.is-checked .el-checkbox__inner {
              background-color: #ff9d01;
              border-color: #ff9d01;
            }

            .el-checkbox__input.is-checked + .el-checkbox__label {
              color: #ff9d01;
            }
          }

          a {
            font-size: 14px;
          }

          a:hover {
            color: #ff9d01;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
